import { Color, GameState } from './state';
import { useSettings } from './useSetting';

export function useActivePhone(): [
	string | undefined,
	(phone: string | undefined) => void,
] {
	const { settings, setValue } = useSettings();
	const phone = settings.activePlayer;
	const setPhone = (value: string | undefined) =>
		setValue('activePlayer', value);
	return [phone, setPhone];
}

export function useActivePlayer(
	state: GameState,
): [Color | undefined, (phone: string | undefined) => void] {
	const [phone, setPhone] = useActivePhone();
	const gamePlayers = new Map<string, Color>([
		[state.players[Color.BLUE].phone, Color.BLUE],
		[state.players[Color.GREEN].phone, Color.GREEN],
		[state.players[Color.RED].phone, Color.RED],
		[state.players[Color.YELLOW].phone, Color.YELLOW],
	]);
	const storedColor = phone === undefined ? undefined : gamePlayers.get(phone);
	return [storedColor, setPhone];
}
